import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { InputOtp } from "primereact/inputotp";
import { Link } from "react-router-dom";
import "./verification.css";
import { getOtpforResendinSignup, verifyLogin, verifyOtpAndSignUp, verifyOtpAndSignUpContractFarming } from "../services/Un_auth_services";
import { useDispatch, useSelector } from "react-redux";
import { OnSignIn ,setUserDet} from "../../../core/data/redux/authSlice";
import { jwtDecode } from "jwt-decode";
import { toast, ToastContainer } from "react-toastify";
import { signIn } from "../services/authServices";
import useAuth from "../../../hooks/useAuth";


const TwoStepVerification3 = () => {
  const dispatch = useDispatch();
  const language = useSelector((state: any) => state.auth.language);
  const navigation = useNavigate();
  const location = useLocation();
  const { signIn } = useAuth();

  const [refId, setRefId] = useState<string | null>(null);
  const [formValuesState, setFormValuesState] = useState(location.state?.formValues || {});
  const [navigatePathState, setNavigatePathState] = useState(location.state?.navigatePath || "");
  const [selectedURL, setSelectedURL] = useState(location.state?.selectedURL || "");
  const [tr, setTr] = useState(location.state?.tr || "");
  const [pr, setPr] = useState(location.state?.pr || "");
  const [token, setTokens] = useState<any>();
  const [isDisabled, setIsDisabled] = useState(false);
  const [isResending, setIsResending] = useState(false);

  const [countdown, setCountdown] = useState(600); 
  const [resendAttempts, setResendAttempts] = useState(0); 

  // Timer effect
  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [countdown]);



  const handleVerifyOtp = async (otpToken = token) => {
    if (!otpToken) {
      alert("Please enter the OTP");
      return;
    }
    setIsDisabled(true);
    try {
      const response =
        navigatePathState === "login"
          ?formValuesState.User_type==="Sponsor"?await verifyOtpAndSignUpContractFarming({ ...formValuesState, enteredOTP: otpToken, navigation }): await verifyOtpAndSignUp({ ...formValuesState, enteredOTP: otpToken, navigation, tr: refId || tr })
          : await verifyLogin({ ...formValuesState, enteredOTP: otpToken, pr: refId || pr });
      if(formValuesState.User_type==="Sponsor"){

      }
      if (response.success === true) {
        alert(response.message);

        if (navigatePathState === "login") {
          const updatedURL = selectedURL.replace("Registration", "Login");
          navigation(`/login?role=${encodeURIComponent(updatedURL)}`);
        } else {
          await dispatch(OnSignIn(response.Body));
          const decodedToken = jwtDecode(response.Body);
          dispatch(setUserDet(decodedToken));
        }
      } else {
        alert(response.Message);
      }
    } catch (error: unknown) {
      let errorMessage = "An unknown error occurred.";
      if ((error as any).response?.data) {
        errorMessage = (error as any).response.data.message || errorMessage;
      }
      alert(errorMessage);
    } finally {
      setIsDisabled(false);
    }
  };

  const handleResendOtpForSignUp = async () => {
    if (isResending || resendAttempts >= 3 || countdown > 0) return; 

    setIsResending(true);
    setCountdown(600); 
    setResendAttempts((prev) => prev + 1);

    try {
      if (!formValuesState) {
        alert("Invalid request. Please try again.");
        return;
      }

      setNavigatePathState("login");
      const response = await getOtpforResendinSignup({ ...formValuesState, tr: refId || tr });

      if (response.Status) {
        alert(response.Message);
        setRefId(response.RefId);
      } else {
        alert("Failed to resend OTP. Please try again.");
      }
    } catch (error) {
      alert("An error occurred while resending OTP.");
    } finally {
      setTimeout(() => setIsResending(false), 30000);
    }
  };
  const handleResendOtpForLogin = async () => {
    if (isResending) return;
    setIsResending(true);
    setCountdown(600); 
    setResendAttempts((prev) => prev + 1);

 
    try {
      if (!formValuesState || !formValuesState.UserName || !formValuesState.password || !formValuesState.userType) {
        alert("Invalid request. Please try again.");
        return;
      }

 
    
      const response = await signIn({
        ...formValuesState,
        refId: refId || pr,
      });
 
 
  
      if (response?.togetVerified) {
        alert(response.Message);
        setRefId(response.RefId); 
      }
      else {
        alert(response.Message || "Failed to resend OTP.");
      }
    } catch (error) {
     
      alert("An error occurred while resending OTP.");
    } finally {
      setTimeout(() => setIsResending(false), 30000); 
    }
  };

  return (
    
    <div className="container-fluid d-flex justify-content-center align-items-center vh-100 mt-5">
      <ToastContainer position="top-left" autoClose={3000} />
      <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
        <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap">
          <div className="col-md-4 mx-auto vh-100">
            <form className="digit-group vh-100">
              <div className="vh-100 d-flex flex-column justify-content-center align-items-center p-4 pb-0">
                <div className="justify-content-center">
                  <div className="text-center mb-3">
                    <h2 className="mb-2 text-success">{language.enter_otp}</h2>
                    <p className="mb-0">{language.otp_heading}</p>
                  </div>
                  <div className="text-center otp-input p-3 border rounded shadow-sm">
                    <div className="d-flex align-items-center justify-content-center mb-3 p-3">
                      <InputOtp value={token} onChange={(e) => setTokens(e.value)} integerOnly />
                    </div>
                    <div className="badge bg-success-transparent mb-3">
                        <p className="d-flex align-items-center">
                          <i className="ti ti-clock me-1" />
                          {Math.floor(countdown / 60)}:{(countdown % 60).toString().padStart(2, "0")}
                        </p>
                    </div>
                    <div className="mb-3 d-flex justify-content-center">
                      <p className="text-gray-9">
                        Didn't get the OTP?{" "}
                        <Link
                            to="#"
                            className={`text-success ${countdown > 0 || resendAttempts >= 3 ? "disabled" : ""}`}
                            style={{ pointerEvents: countdown > 0 || resendAttempts >= 3 ? "none" : "auto" }}

                            onClick={
                              navigatePathState === "login"
                                ? handleResendOtpForSignUp
                                : handleResendOtpForLogin
                            }
                          >
                             {isResending
                            ? "Resending..."
                            : resendAttempts >= 3
                            ? "Resend limit reached"
                            : countdown > 0
                            ? `Resend`
                            : language.resend}
                        </Link>
                      </p>
                    </div>
                  </div>
                  <div className="mb-3">
                    <button
                      type="button"
                      onClick={() => handleVerifyOtp(token)}
                      disabled={isDisabled}
                      className="btn btn-success w-100"
                    >
                      {isDisabled ? "Processing..." : language.verify}
                    </button>
                  </div>
                </div>
                <div className="mt-5 pb-4 text-center"></div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TwoStepVerification3;



